import { FC, useMemo, useState } from 'react';
import { RemoteConfigUtils } from '~/utils/RemoteConfigUtils';
import { DentalHygienistIcon } from '~/images/ShiftRequest/DentalHygienistIcon';
import { DentalAssistantIcon } from '~/images/ShiftRequest/DentalAssistantIcon';
import { EfdaIcon } from '~/images/ShiftRequest/EfdaIcon';
import { AssociateDentistIcon } from '~/images/ShiftRequest/AssociateDentistIcon';
import { FrontDeskIcon } from '~/images/ShiftRequest/FrontDeskIcon';

export interface IProfessionOption {
  code: string;
  label: string;
  icon: FC;
}

interface IUseSelectProfessionTypeProps {
  officeState: string;
}

const PROFESSION_DISPLAY_ORDER: IProfessionOption[] = [
  { code: 'RDH', label: 'Dental Hygienist', icon: DentalHygienistIcon },
  { code: 'DA', label: 'Dental Assistant', icon: DentalAssistantIcon },
  { code: 'EFDA', label: 'Expanded Functions DA', icon: EfdaIcon },
  { code: 'DN', label: 'Associate Dentist', icon: AssociateDentistIcon },
  { code: 'FD', label: 'Front Desk', icon: FrontDeskIcon },
];

export const useSelectProfessionType = ({ officeState }: IUseSelectProfessionTypeProps) => {
  const [selectedProfession, setSelectedProfession] = useState<string | null>(null);

  const availableProfessions = useMemo(() => {
    const professionsByState = RemoteConfigUtils.getProfessionsByState();

    const stateProfessions = professionsByState[officeState] ?? [];

    return PROFESSION_DISPLAY_ORDER.filter((profession) =>
      stateProfessions.includes(profession.code),
    );
  }, [officeState]);

  const isConfirmDisabled = selectedProfession === null;

  return {
    availableProfessions,
    selectedProfession,
    setSelectedProfession,
    isConfirmDisabled,
  };
};
